/* eslint-disable prefer-arrow-callback, func-names, no-var */

$(function () {
    var sidemenuTablet = function () {
        var sidemenu = $('.sidebar.is-menu nav');
        var menuWidth = 0;

        sidemenu.find('.nav-aside-toplevel-li').each(function () {
            menuWidth += $(this).outerWidth();
        });

        if (menuWidth + 30 > sidemenu.width()) {
            $('.sidebar.is-menu').addClass('is-overflow-scroll');
        } else {
            $('.sidebar.is-menu nav ul').first().css('width', '100%');
            $('.sidebar.is-menu').removeClass('is-overflow-scroll');
        }
    };
    $(window).on('resize', function () {
        if ($(this).width() < 1024) {
            sidemenuTablet();
        }
    }).trigger('resize');
});

$(function () {
    var ecoleMenuTablet = function () {
        var sidemenu = $('.content-centered-fiche-menu-wrapper');
        var menuWidth = 0;

        sidemenu.find('.content-centered-fiche-menu-element').each(function () {
            menuWidth += $(this).outerWidth();
        });

        if (menuWidth > sidemenu.width()) {
            sidemenu.addClass('is-overflow-scroll');
        } else {
            sidemenu.removeClass('is-overflow-scroll');
        }
    };
    $(window).on('resize', function () {
        if ($(this).width() < 1024) {
            ecoleMenuTablet();
        }
    }).trigger('resize');
});
